import { render, staticRenderFns } from "./DtrView.vue?vue&type=template&id=60406bf3"
import script from "./DtrView.vue?vue&type=script&lang=js"
export * from "./DtrView.vue?vue&type=script&lang=js"
import style0 from "./DtrView.vue?vue&type=style&index=0&id=60406bf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports